import locale from "@/helpers/locale";
import { currencyFormatter } from "@/utils/filters";
import { toThousands } from "@/utils/common.js";

export const thead_fn = () => {
  return [
    {
      label: locale("client.partner.name"),
      prop: "clientName",
      width: 200,
      align: "left",
    },
    {
      label: locale("global.titleOfWork"),
      prop: "filmName",
      width: 200,
      align: "left",
    },
    {
      label: locale("trans.report.period"),
      prop: "dateRange",
      width: 70,
      align: "center",
    },
    {
      label: locale("couponLib.ticketType"),
      prop: "ticketTypeRecord",
      width: 50,
      align: "center",
    },
    {
      label: locale("trans.report.mobolizenumber"),
      prop: "mobilizeNumber",
      width: 60,
      align: "right",
      formatter: (row, column, cellValue) => {
        return toThousands(cellValue);
      },
    },
    {
      label: locale("filmFeePdf.salesAmount"),
      prop: "salesAmount",
      width: 90,
      align: "right",
      formatter: (row, column, cellValue) => {
        return currencyFormatter(cellValue);
      },
    },
    {
      label: locale("filmFeePdf.rate"),
      prop: "rate",
      width: 40,
      align: "right",
      formatter: (row, column, cellValue) => {
        return cellValue === "" ? "" : `${cellValue}%`;
      },
    },
    {
      label: locale("filmFeePdf.filmFee"),
      prop: "filmFee",
      width: 80,
      align: "right",
      formatter: (row, column, cellValue) => {
        return currencyFormatter(cellValue);
      },
    },
    {
      label: locale("filmFeePdf.filmFeeTotal"),
      prop: "filmFeeTotal",
      width: 90,
      align: "right",
      formatter: (row, column, cellValue) => {
        return currencyFormatter(cellValue);
      },
    },
  ];
};

const dataTypeArray = [
  "boxOffice",
  "morningShow",
  "lateShow",
  "allNight",
  "special",
];

const getTicketType = key => {
  const _ticketTypeRecord = key === "boxOffice" ? locale("filmFeePdf.boxOffice") : key === "morningShow"
    ? locale("filmFeePdf.morningShow") : key === "lateShow"
      ? locale("filmFeePdf.lateShow") : key === "allNight"
        ? locale("filmFeePdf.allNight") : locale("filmFeePdf.special");

  return _ticketTypeRecord;
};

const dataConsolidation = ({
  targetObj,
  clientName = "",
  filmName = "",
  filmFeeTotal,
  dateRange = "",
  dataCounts = 1,
  isTotalRow = false,
  isSumsRow = false,
  isFilmTotalRow = false,
  sumRowCounts = false,
}) => {
  let _resultArray = [];

  dataTypeArray.forEach((_key, index) => {
    if (typeof (targetObj[_key]) === "object" && targetObj[_key] !== null) {
      const { mobilizeNumber, salesAmount, rate, filmFee } = targetObj[_key];
      // const _filmFeeTotal = index + 1 === dataTypeArray.length ? filmFeeTotal : "";
      const _ticketTypeRecord = getTicketType(_key);

      const arrData = {
        clientName,
        filmName,
        dateRange,
        // filmFeeTotal: _filmFeeTotal,
        filmFeeTotal,
        mobilizeNumber,
        salesAmount,
        rate: rate === null ? "-" : rate,
        filmFee: filmFee === null ? "-" : filmFee,
        ticketTypeRecord: _ticketTypeRecord,
        rowspan: dataCounts * 5,
        isTotalRow,
        isSumsRow,
        isFilmTotalRow,
        ...(sumRowCounts ? { sumRowCounts: index === 0 } : {}),
      };

      _resultArray.push(arrData);
    }
  });

  return _resultArray;
};

export const formatData = data => {
  const { records = [], allTotal = [] } = data;

  if (records.length === 0) {
    return [];
  }

  let _tableData = [];
  records.forEach(_record => {
    const { filmRecords, clientTotal, clientCode, clientName } = _record;
    // const _clientName = clientCode ? `[${clientCode}] ${clientName}` : clientName;

    filmRecords.forEach((_film, _fIndex) => {
      const { filmSearchId, filmName, dateRangeRecords, filmTotal } = _film;
      const _filmName = filmSearchId ? `[${filmSearchId}] ${filmName}` : filmName;

      dateRangeRecords.forEach((_range, _rIndex) => {
        const { ticketTypeRecord, dateRange, filmFeeTotal } = _range;
        // const __clientName = _fIndex === 0 && _rIndex === 0 ? _clientName : "";
        const __clientName = clientName;
        // const __filmName = _rIndex === 0 ? _filmName : "";
        const __filmName = filmName;
        const _drArray = dataConsolidation({
          targetObj: ticketTypeRecord,
          clientName: __clientName,
          filmName: __filmName,
          filmFeeTotal,
          dateRange,
          dataCounts: dateRangeRecords.length,
        });

        _tableData = [
          ..._tableData,
          ..._drArray,
        ];

      });

      const _ftArray = dataConsolidation({
        clientName: locale("filmFeePdf.workPlan"),
        targetObj: filmTotal,
        filmFeeTotal: filmTotal.filmFeeTotal,
        dataCounts: filmRecords.length,
        isFilmTotalRow: true,
      });

      _tableData = [
        ..._tableData,
        ..._ftArray,
      ];
    });

    const _ctArray = dataConsolidation({
      clientName: locale("filmFeePdf.rationMeter"),
      targetObj: clientTotal,
      filmFeeTotal: clientTotal.filmFeeTotal,
      isTotalRow: true,
    });

    _tableData = [
      ..._tableData,
      ..._ctArray,
    ];
  });

  const _atArray = dataConsolidation({
    clientName: locale("filmFeePdf.total"),
    targetObj: allTotal,
    filmFeeTotal: allTotal.filmFeeTotal,
    isSumsRow: true,
    sumRowCounts: true,
  });

  _tableData = [
    ..._tableData,
    ..._atArray,
  ];

  const arrData = {
    clientName: locale("filmFeePdf.total"),
    filmName: "",
    filmFeeTotal: "",
    mobilizeNumber: allTotal.sumMobilizeNumber,
    salesAmount: allTotal.sumSalesAmount,
    rate: "",
    filmFee: "",
    ticketTypeRecord: locale("filmFeePdf.sums"),
    isSumsRow: true,
  };

  _tableData.push(arrData);

  return _tableData;
};